import { render, staticRenderFns } from "./LeftMenuTree.vue?vue&type=template&id=3bc7dea6&"
import script from "./LeftMenuTree.vue?vue&type=script&lang=js&"
export * from "./LeftMenuTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports